import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ScriptLoaderService {
    private scripts: { [url: string]: Promise<void> | null } = {};

    async loadScript(url: string): Promise<void> {
        if (this.scripts[url]) {
            // await this.scripts[url];
            return;
        }

        this.scripts[url] = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            if (url.endsWith('.mjs')) script.type = 'module';

            script.src = url;

            script.onload = () => {
                resolve();
            };
            script.onerror = () => {
                delete this.scripts[url];
                reject(new Error(`Failed to load script: ${url}`));
            };
            document.head.appendChild(script);
        });

        await this.scripts[url];
    }
}
